import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { Routes } from '@angular/router';
import { PermissionResponse } from '../core/base-api';
import { ConfigurationRoutes } from './configuration/configuration.routes';
import { EigentuemerlisteRoutes } from './eigentuemeradressliste/eigentuemerliste.routes';
import { BatchAuftragRoutes } from './batch-auftrag/batch-auftrag.routes';
import { Ech0134Routes } from '../ech0134/ech0134.routes';
import { ErweitertesSuchregisterRoutes } from './erweitertes-suchregister/erweitertes-suchregister.routes';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const SystemRoutes: Routes = [
  {
    path: 'system',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN]
    },
    children: [...ConfigurationRoutes, ...EigentuemerlisteRoutes, ...BatchAuftragRoutes, ...Ech0134Routes, ...ErweitertesSuchregisterRoutes]
  }
];
